import { modifier } from 'ember-modifier'

/**
 * This modifier it will call the function on render and whenever the given args change.
 *
 * This is useful for table data, it allows us to watch properties and call an action to update / transform data on any
 * changes.
 *
 * // template.hbs
 * <div {{do-action (fn this.dataAction this.prop1)}} />
 * OR for a task
 * <div {{do-action (perform this.dataTask this.prop1)}} />
 *
 * // component.js
 * @action
 * dataAction(prop1, _element) {
 *   // do thing
 * }
 *
 * dataTask = task(prop1, _element) {
 *   return this.store.query(...)
 * })
 */

interface Signature {
  Args: {
    Named: Record<string, unknown>
    Positional: unknown[]
  }
  Element: HTMLElement
}

export const doAction = modifier<Signature>(function doAction(element, positional, _named) {
  const [fn, ...args] = positional
  if (typeof fn === 'function') {
    fn(element, ...args)
  }
})

export default doAction
